export const blogPosts = [
  {
    slug: "tenant-spotlight-house-of-baby",
    title: "Tenant spotlight – house of baby",
    heroImageUrl: "/static/images/house-of-baby.webp",
    content: `house of baby is an ongoing collaborative project between Joseph Losper & Tomio Shota.

house of baby celebrates space, creating a new world with new boundaries, currently making rugs for the explorers who never grew up. They have collaborated on projects with Bao London for Dover Street Market & created rug art-pieces for By Sebastian.

Their studio is small but mighty with a playful & surreal sense of fun, which is something that is at the core of how Joseph & Tomio approach their creative work.

They are based out of Unit 13 in South Bermondsey. Thank you for having us over to visit 🌸`,
  },
  {
    slug: "tenant-spotlight-leah-hayden-cassidy",
    title: "Tenant spotlight – Leah Hayden Cassidy",
    heroImageUrl: "/static/images/leah-hayden-cassidy.webp",
    content: `Precise, well versed & crafty with a blade or two, Leah Hayden Cassidy is a standout talent in the barbering world; challenging the norms of what a barber should look like.

Dublin-born, London based, Cassidy started barbering in 2015, aged 22. With a lot of love & dedication to her craft she has amassed a dedicated following & has recently signed her first luxury deal with Dior, becoming their grooming expert in the UK. The Financial Times has just done a great piece on her too, so you know she means business.

Her studio is intimate, industrial & it feels like you're hanging out with a mate. There is a custom made vinyl cabinet, where you can whack on a record, with quite a few of the names in there being current customers of hers. No biggie.

She is based out of Gransden Works in London Fields & we love what she's done with the place!`,
  },
  {
    slug: "tenant-spotlight-alexander-hills-architects",
    title: "Tenant spotlight – Alexander Hills Architects",
    heroImageUrl: "/static/images/alexander-hills-architects.webp",
    content: `Based out of Gransden Works in London Fields, AH A is a local architecture & design studio that is craft-led; characterised by a sense of refinement, subtlety & humour.

Current projects include a fit-out of a duplex flat in King's Cross, an extension/refurbishment of a detached house in North Norfolk & the design of a new kitchen in an Art Deco block in Highgate.

AH A hosts other design practices on an ad hoc basis, which brings a sense of collaboration & exploration within their community.

The studio feels spacious & practical, but with a fantastic sense of playfulness in design & colour use.`,
  },
  {
    slug: "tenant-spotlight-body-in-sync",
    title: "Tenant spotlight – Body In Sync",
    heroImageUrl: "/static/images/body-in-sync.webp",
    content: `Rob is an experienced fitness professional with more than 35 years of experience. Having started his career in South Africa, he studied fitness techniques such as aerobics, circuits, step & body conditioning classes.

In 2011, Rob moved to the UK to continue with his extensive pilates training, while also regularly teaching internationally & running training courses in the UK.

Being one of our first tenants at Paynes Wharf, he had first dibs on picking a space & so he chose a corner unit with the best views, overlooking the Thames, Canary Wharf & Greenwich.

Rob is passionate about teaching & motivating his clients with encouragement, compassion and careful attention to personal goals.`,
  },
  {
    slug: "tenant-spotlight-alchemist-barber-company",
    title: "Tenant spotlight – Alchemist Barber Company",
    heroImageUrl: "/static/images/alchemist-barber-company.webp",
    content: `Alfred & Hus opened the Alchemist Barber Company in 2015 & it's their home away from home. They used to have a shop down the road, but decided to move & relocate with us.

They are one of our first tenants at Platform East & when we went to visit them they were so busy, but the whole atmosphere felt so relaxed.

Their studio looks out onto Morning Lane. It felt so good to look up & see the building look alive again, after being neglected for so long.

Hit them up for some barbering or hairdressing. They do both & do it well ⚡️`,
  },
];

export function getBlogPostBySlug(slug) {
  return blogPosts.find((p) => p.slug === slug) || null;
}